import axios from 'axios';

const getApiConfig = () => {
    const env = process.env.REACT_APP_ENV || 'development';
    const baseURL = process.env.REACT_APP_API_URL;

    // Create axios instance with environment specific config
    const api = axios.create({
        baseURL,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });

    
    // Add request interceptor
    api.interceptors.request.use((config) => {
        // Add auth token if available
        const token = localStorage.getItem('authToken');
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    // Add response interceptor
    api.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                // Handle unauthorized access
                localStorage.removeItem('authToken');
                window.location.href = '/login';
            }
            
            return Promise.reject(error);
        }
    );

    api.interceptors.response.use(null, async (error) => {
        if (error.response?.status === 429) {  // Too Many Requests
            const retryAfter = error.response.headers['retry-after'] || 5;
            await new Promise(resolve => setTimeout(resolve, retryAfter * 1000));
            return api.request(error.config);
        }
        return Promise.reject(error);
    });
    return api;
};

export const apiClient = getApiConfig();

// Common API functions
// export const makeApiRequest = async (method, endpoint, data = null, customConfig = {}) => {
//     try {
//         const config = {
//             method,
//             url: endpoint,
//             ...customConfig
//         };

//         if (data) {
//             config.data = data;
//         }

//         const response = await apiClient(config);
//         return response.data;
//     } catch (error) {
//         console.error(`API Error (${endpoint}):`, error);
//         throw error;
//     }
// }; 

export const makeApiRequest = async (method, endpoint, data = null, customConfig = {}) => {
    try {
        const config = {
            method,
            url: endpoint,
            ...customConfig
        };

        if (data) {
            config.data = data;
        }

        // Handle file download for template
        if (endpoint.includes('/download-template')) {
            config.responseType = 'blob'; // Expect binary response
        }

        const response = await apiClient(config);

        // Handle file download response
        if (endpoint.includes('/download-template')) {
            const blob = response.data;
            const contentDisposition = response.headers['content-disposition'];
            const filename = contentDisposition
                ? contentDisposition.split('filename=')[1].replace(/"/g, '')
                : 'lead_template.xlsx';
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            return { status: 'success' };
        }

        return response.data;
    } catch (error) {
        console.error(`API Error (${endpoint}):`, error);
        throw error;
    }
};